import React from 'react';
import classNames from 'classnames/bind';
import { defaultPropArray } from "../constants";
import { Chat, Phone } from "../icons";
import { TextBase } from "../internal/TextBase";
import FooterBottom from '../FooterBottom';
import IconRound from '../IconRound';
import Title from '../Title';
import FooterForm from './components/Form';
import styles from './Footer.css';
var cx = classNames.bind(styles);

var Footer = function Footer(_ref) {
  var appstoreLink = _ref.appstoreLink,
      _ref$callInMoscowTitl = _ref.callInMoscowTitle,
      callInMoscowTitle = _ref$callInMoscowTitl === void 0 ? 'Москва +7 495 783–0707' : _ref$callInMoscowTitl,
      _ref$callInRussiaTitl = _ref.callInRussiaTitle,
      callInRussiaTitle = _ref$callInRussiaTitl === void 0 ? 'Бесплатно по России +7 800 700–0707' : _ref$callInRussiaTitl,
      _ref$chatTitle = _ref.chatTitle,
      chatTitle = _ref$chatTitle === void 0 ? 'Чат' : _ref$chatTitle,
      googleplayLink = _ref.googleplayLink,
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'en' : _ref$language,
      _ref$navLinks = _ref.navLinks,
      navLinks = _ref$navLinks === void 0 ? defaultPropArray : _ref$navLinks,
      _ref$newsletterTitle = _ref.newsletterTitle,
      newsletterTitle = _ref$newsletterTitle === void 0 ? 'Новостная рассылка' : _ref$newsletterTitle,
      _ref$onlineCallTitle = _ref.onlineCallTitle,
      onlineCallTitle = _ref$onlineCallTitle === void 0 ? 'Звонок онлайн' : _ref$onlineCallTitle,
      socialsList = _ref.socialsList,
      onCall = _ref.onCall,
      onChat = _ref.onChat,
      onSubmit = _ref.onSubmit,
      validate = _ref.validate;
  var chunkSize = Math.ceil(navLinks.length / 3);
  var chunks = navLinks.reduce(function (acc, link, index) {
    var chunk = Math.floor(index / chunkSize);
    acc[chunk].push(link);
    return acc;
  }, [[], [], []]);
  return /*#__PURE__*/React.createElement("footer", {
    className: cx('Footer')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Top')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Wrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('TopInner')
  }, navLinks.length > 0 && /*#__PURE__*/React.createElement("nav", {
    className: cx('NavLinks')
  }, chunks.map(function (chunk, index) {
    return (
      /*#__PURE__*/
      // eslint-disable-next-line react/no-array-index-key
      React.createElement("div", {
        key: index,
        className: cx('Column')
      }, /*#__PURE__*/React.createElement("ul", {
        className: cx('List')
      }, chunk.map(function (_ref2) {
        var title = _ref2.title,
            href = _ref2.href,
            key = _ref2.key;
        return /*#__PURE__*/React.createElement("li", {
          key: key,
          className: cx('ListItem')
        }, /*#__PURE__*/React.createElement("a", {
          href: href,
          className: cx('Link')
        }, /*#__PURE__*/React.createElement(TextBase, null, title)));
      })))
    );
  })), /*#__PURE__*/React.createElement("div", {
    className: cx('TopRight')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('Contacts')
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('List')
  }, /*#__PURE__*/React.createElement("li", {
    className: cx('ListItem')
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:+78007000707",
    className: cx('Link')
  }, /*#__PURE__*/React.createElement(TextBase, null, callInRussiaTitle))), /*#__PURE__*/React.createElement("li", {
    className: cx('ListItem')
  }, /*#__PURE__*/React.createElement("a", {
    href: "tel:+74957830707",
    className: cx('Link')
  }, /*#__PURE__*/React.createElement(TextBase, null, callInMoscowTitle)))), /*#__PURE__*/React.createElement("div", {
    className: cx('Actions')
  }, onCall && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onCall,
    className: cx('ActionButton')
  }, /*#__PURE__*/React.createElement(IconRound, null, /*#__PURE__*/React.createElement(Phone, null)), ' ', /*#__PURE__*/React.createElement("div", {
    className: cx('ActionsText')
  }, /*#__PURE__*/React.createElement(TextBase, null, onlineCallTitle))), onChat && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: onChat,
    className: cx('ActionButton')
  }, /*#__PURE__*/React.createElement(IconRound, null, /*#__PURE__*/React.createElement(Chat, null)), ' ', /*#__PURE__*/React.createElement("div", {
    className: cx('ActionsText')
  }, /*#__PURE__*/React.createElement(TextBase, null, chatTitle))))), onSubmit && /*#__PURE__*/React.createElement("div", {
    className: cx('News')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('NewsTitle')
  }, /*#__PURE__*/React.createElement(Title, {
    level: 5
  }, newsletterTitle)), /*#__PURE__*/React.createElement(FooterForm, {
    onSubmit: onSubmit,
    validate: validate
  })))))), /*#__PURE__*/React.createElement(FooterBottom, {
    socialsList: socialsList,
    appstoreLink: appstoreLink,
    googleplayLink: googleplayLink,
    language: language
  }));
};

export default Footer;